

















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AxiosError } from 'axios';


import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { CommentRepository } from "@api/repositories/CommentRepository";
import { UserRepository } from "@api/repositories/UserRepository";

import { CommentQueryParametersInterface } from "@api/repositories/interfaces/CommentQueryParametersInterface";

import { UserProfile } from "@api/models/UserProfile";
import { Comment } from "@api/models/comments/Comment";
import { CommentsBlock } from '@api/models/comments/CommentsBlock';
import {Element} from "@api/models/Element";
import {Popup} from '@api/models/Popup';

import CommentView from './Comment.vue';
import CommentTextarea from './CommentTextarea.vue';
import CloseBtn from '@share/common/CloseBtn.vue';
import BounceSpinner from "@share/common/BounceSpinner.vue";

import { ArrayHelpers } from '@common/ArrayHelpers';
import {Modal} from "@common/Modal";

@Component({
  name: 'CommentsView',
  components: { CommentView, CloseBtn, CommentTextarea, BounceSpinner },
})
export default class CommentsView extends Vue implements EventListenerObject {
  static MIN_TIME = '2001-01-01 00:00:00';
  static MIN_OFFSET_FOR_AUTOSCROLLING = 70;

  @Prop({ required: true }) objectId: string;
  @Prop({ required: true }) schemaId: string;
  @Prop({ required: true }) statuses: Element[];
  @Prop({ default: false }) readOnly: boolean;
  @Prop({ default: null }) hideUserId: number | null; // идентификатор пользователя, являющегося автором анонимного тикета

  commentRepository: CommentRepository;
  userRepository: UserRepository;

  isSending = false;
  comments: Comment[] = [];
  commentsAfter = 0;
  commentsBefore = 0;
  commentators: Record<string, UserProfile> = {};
  message = '';
  commentIdToAnswer = '';
  threadIdToAnswer = '';
  userIdToAnswer = '';
  lastUpdatedAt = CommentsView.MIN_TIME;
  isShowAnswerPanel = true;
  editedComment: Comment | null = null;
  scrollState = { top: 0, scrolledUp: 0, needScrollBottom: false, height: 0 };
  error = false;
  isLoading = true;

  // Vue hooks
  async created() {
    this.commentRepository = this.$repositories.get(RepositoryFabric.COMMENT);
    this.userRepository = this.$repositories.get(RepositoryFabric.USER);
  }

  async mounted() {
    document.addEventListener('visibilitychange', this);
    await this.refreshComments();
    this.isLoading = false;
  }

  deactivated() {
    document.removeEventListener('visibilitychange', this);
  }

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this);
  }

  get commentsCount() {
    return this.comments?.length;
  }

  // Vue computed fields
  get answerToUser(): string {
    return this.commentators[this.userIdToAnswer] ? this.commentators[this.userIdToAnswer].firstName + ',' : '';
  }

  get isAdmin() {
    return this.$store.getters['isAdmin'];
  }

  get filteredComments() {
    return this.comments;
  }

  get eventAdminGroups() {
    return this.$store.getters['services/getServiceParam']('eventsManagement', 'administratorGroupIds') || [];
  }

  get isMeeting() {
    return this.schemaId === 'Meetings';
  }

  get isOnEditing() {
    return this.editedComment?.isOnEdit || false;
  }

  get lang() {
    return this.$store.state.session?.language ?? 'en';
  }

  // API calls
  private async fetchComments(query: CommentQueryParametersInterface) {
    return await this.commentRepository.query(this.schemaId, this.objectId, query);
  }

  private async getCommentUpdates() {
    return await this.commentRepository.updates(this.schemaId, this.objectId, this.lastUpdatedAt);
  }

  private async fetchСommentators(userIds: Array<number>) {
    const query = {
      where: {
        userId: {
          $in: userIds,
        },
      },
      include: ['id', 'userId', 'lastName', 'firstName', 'photoFileId', 'groupIds'],
      take: -1,
    };
    return await this.userRepository.profiles(query);
  }

  private async send() {
    let comment: Comment;

    if (this.isSending || !this.message) {
      return;
    }

    this.isSending = true;

    try {
      if (this.commentIdToAnswer) {
        comment = await this.commentRepository.sendCommentAnswer(this.schemaId, this.objectId, this.commentIdToAnswer, JSON.stringify(this.message));
        const commentIndex = this.comments.findIndex(
          item => item.id === (this.threadIdToAnswer ? this.threadIdToAnswer : this.commentIdToAnswer),
        );
        if (this.comments[commentIndex].thread === null) {
          const newBlock: CommentsBlock = new CommentsBlock({ comments: [], nextCount: 0, previousCount: 0 });
          this.comments[commentIndex].thread = newBlock;
        }
        (this.comments[commentIndex].thread as CommentsBlock).comments.push(comment);
      } else {
        comment = await this.commentRepository.sendComment(this.schemaId, this.objectId, this.message, this.isQuestion(this.message) ? 'question' : null);
        this.comments.push(comment);
      }

      if (comment.userId && !this.commentators[comment.userId]) {
        const myProfile = await this.fetchСommentators([comment.userId]);
        this.updateCommentatorProfiles(myProfile);
      }

      this.message = '';
      this.commentIdToAnswer = '';
      this.threadIdToAnswer = '';
      this.userIdToAnswer = '';
      this.$nextTick(() => {
        const inputArea = this.$refs['inputArea'] as Vue;
        inputArea && (inputArea.$el as HTMLElement).focus();
        this.scrollToComment(comment);
      });
    } catch (e) {
      this.$store.dispatch('reportError', e);
    } finally {
      this.isSending = false;
    }
  }

  // Helpers
  private getUserIdsFromComments(comment: Comment): Array<number> {
    if (comment.thread) {
      return comment.thread.comments.map(item => item.userId).concat(comment.userId);
    }
    return [comment.userId];
  }

  private lastUpdatedComment(comments: Array<Comment>): Comment {
    return comments.reduce((result, current) => {
      let lastComment: Comment = current;
      if (current.thread) {
        lastComment = this.lastUpdatedComment(current.thread.comments);
        lastComment = lastComment.updatedAt > current.updatedAt ? lastComment : current;
      }
      return result.updatedAt > lastComment.updatedAt ? result : lastComment
    }, comments[0]);
  }

  private getProfilesForThread(comment: Comment) {
    const userIds = [...new Set(this.getUserIdsFromComments(comment))],
      profiles: Record<string, UserProfile> = {};
    userIds.forEach(id => {
      if (this.commentators[id]) {
        profiles['' + id] = new UserProfile(this.commentators[id]);
      }
    });
    return profiles;
  }

  private updateCommentatorProfiles(commentatorProfiles: UserProfile[]) {
    commentatorProfiles.forEach(item => {
      Vue.set(this.commentators, '' + item.userId, new UserProfile(item));
    });
  }

  private addAnonymousProfile() {
    if (this.hideUserId) {
      Vue.set(this.commentators, '' + this.hideUserId, {
        id: '' + this.hideUserId,
        lastName: this.$t("tickets.of problem").toString(),
        firstName: this.$t("tickets.author").toString(),
        middleName: '',
        photoFileId: undefined,
        userId: this.hideUserId,
        updatedAt: undefined,
      });
    }
  }

  // возвращает идентификаторы пользователей из переданного в параметре массива, которые еще не были загружены с бекенда
  private notLoadedUserProfiles(userIds: number[]) {
    const absentUserIds: number[] = [];
    userIds.forEach(id => {
      if (!this.commentators['' + id]) {
        absentUserIds.push(id);
      }
    });
    return absentUserIds;
  }

  // загружает профили пользователей, которых нет в массиве commentators компонента
  private async loadAbsentUserProfiles(userIds: number[]) {
    const absentUserIds = this.notLoadedUserProfiles([...new Set(userIds)]);

    if (absentUserIds.length) {
      this.updateCommentatorProfiles(await this.fetchСommentators(absentUserIds));
    }
  }

  // ищет комментарий в переданном массиве, если находит, то обновляет, в противном случае добавляет новый
  // возвращает true, если комментарий был найден и обновлен, false в противном случае
  findAndUpdateComment(array: Array<Comment>, comment: Comment) {
      let index = ArrayHelpers.findLastIndex(array, (value) => {
          return comment.createdAt > value.createdAt ||
              comment.id === value.id;
          }),
      result = false;

    if (index === -1) {
      index = 0;
      array.splice(0, 0, comment);
    } else {
      if (comment.id === array[index].id) {
        array[index].text = comment.text;
        array[index].isDeleted = comment.isDeleted;
        array[index].updatedAt = comment.updatedAt;
        result = true;
      } else {
        if (index === array.length - 1) {
          array.push(comment);
        } else {
          array.splice(index + 1, 0, comment);
        }
      }
    }
    return result;
  }

  // ищет комментарий в тредах переданного массива
  // если тред существует, то комментарий в треде обновляется или в тред добавляется новый, функция возвращает true
  // если тред не существует, то возвращается false
  findAndUpdateCommentInThreads(array: Array<Comment>, comment: Comment, needUpdateCounter = true) {
    const index = ArrayHelpers.findLastIndex(array, value => value.id === comment.threadId);
    if (index >= 0) {
      if (array[index].thread) {
        if (!this.findAndUpdateComment((array[index].thread as CommentsBlock).comments, comment) && needUpdateCounter) {
          this.$emit('newComment', comment);
        }
      } else {
        array[index].thread = new CommentsBlock({ comments: [], nextCount: 0, previousCount: 0 });
        (array[index].thread as CommentsBlock).comments.push(comment);
        if (needUpdateCounter) {
          this.$emit('newComment', comment);
        }
      }
      return true;
    }
    return false;
  }

  deleteCommentFromFirstLevel(array: Array<Comment>, commentId: string): boolean {
    const index = ArrayHelpers.findLastIndex(array, value => {
      return commentId === value.id;
    });
    if (index !== -1) {
      array[index].delete();
      return true;
    }
    return false;
  }

  isQuestion(message: string) {
    return message.search(/.*\?+.*/gi) !== -1;
  }

  setError(value: boolean) {
    this.error = value;
  }

  scrollToComment(comment: Comment) {
    console.log('scroll to comment ', comment)
    const element: HTMLElement | null = document.getElementById(`cid-${comment.id}`);
    console.log('element to scroll ', element)
    if (element) {
      const offset: number = element.offsetTop - (this.$refs['wrapper'] as HTMLElement).offsetTop;
      this.scrollCommentsTo(offset);
      this.highlightComment(comment);
    }
  }

  scrollCommentsToBottom(immediately = false) {
    this.scrollCommentsTo((this.$refs['wrapper'] as HTMLElement).scrollHeight, immediately);
  }

  scrollCommentsToTop(immediately = false) {
    this.scrollCommentsTo(0, immediately);
  }

  scrollCommentsTo(pixels: number, immediately = false) {
    const box = this.$refs['wrapper'] as HTMLElement;
    // immediately && box.classList.remove('--smooth-scroll');
    console.log('scrolled container ', box)
    box.scrollTop = pixels;
    // immediately && box.classList.add('--smooth-scroll');
  }

  // предобработка комментария
  preprocessComment(comment: Comment) {
    return comment;
  }

  // Event handlers
  private async onGetPrevComments(obj: Record<string, string>) {
    const commentBlock = await this.fetchComments({ direction: 'Older', commentId: obj.commentId, threadId: obj.threadId }),
      commentIndex = this.comments.findIndex(item => item.id === obj.threadId),
      userIds = [...new Set(commentBlock.comments.map((item: Comment) => item.userId))];

    this.loadAbsentUserProfiles(userIds as number[]);

    if (this.comments[commentIndex].thread !== null) {
      (this.comments[commentIndex].thread as CommentsBlock).previousCount = commentBlock.previousCount;
      (this.comments[commentIndex].thread as CommentsBlock).comments = commentBlock.comments.concat(
        (this.comments[commentIndex].thread as CommentsBlock).comments,
      );
    }
  }

  private onAnswer(obj: Record<string, string>) {
    const panel = this.$refs.panel as HTMLElement,
      inputArea = this.$refs.inputArea as Vue;

    this.commentIdToAnswer = obj.commentId;
    this.threadIdToAnswer = obj.threadId;
    this.userIdToAnswer = obj.userId;

    (inputArea.$el as HTMLElement).focus();
  }

  private answerPanelClose() {
    this.threadIdToAnswer = '';
    this.commentIdToAnswer = '';
    this.userIdToAnswer = '';
  }

  private async onDelete(item: { comment: Comment; isConfirmed: boolean }) {
    let confirmResult;

    if (!item.isConfirmed) {
      const modal = new Modal({
        title: this.$t("comments.delete confirmation").toString(),
        buttons: [
          {
            text: this.$t("common.yes").toString(),
            class: 'is-red',
            returnValue: true,
          },
          {
            text: this.$t("common.no").toString(),
            class: 'is-transparent-grey',
            returnValue: false,
          },
        ],
      });

      confirmResult = await modal.showConfirm();
    }

    if (item.isConfirmed || confirmResult === true) {
      try {
        await this.commentRepository.delete(item.comment.id);
        this.deleteComment(item.comment.id);
      } catch (e) {
        this.handleServerError(e);
      }
    }
  }

  private onEditStart(comment: Comment) {
    this.setEditedComment(comment);
  }

  private onCancelEdit(comment: Comment) {
    this.setEditedComment(null);
    this.scrollOnEdit(comment);
  }

  private async onEdit(comment: Comment, message: string) {
    const originMessage = comment.text;
    comment.text = message;

    try {
      await this.commentRepository.edit(comment.id, message);
      this.scrollOnEdit(comment);
    } catch (e) {
      comment.text = originMessage;
      this.handleServerError(e);
    }
  }

  setEditedComment(comment: Comment | null) {
    this.editedComment = comment;
  }

  private scrollOnEdit(comment: Comment) {
    const element: HTMLElement | null = this.getCommentElement(comment);
    if (element) {
      const croppedAtTop = element.offsetTop - this.scrollState.top < 0;
      const croppedAtBottom = element.offsetTop - this.scrollState.top + element.scrollHeight > this.scrollState.height;

      if (croppedAtTop || croppedAtBottom) {
        //если элемент находится за скролом или часть его находится за скролом
        this.scrollToComment(comment);
      } else {
        this.highlightComment(comment);
      }
    }
  }

  // обновление комментариев, пришедших в realtime режиме
  private async onReceiveCommentsUpdates(comments: Comment[]) {
    const userIds = comments.map(comment => comment.userId);

    if (Object.keys(this.commentators).length < 1) {
      await this.loadAbsentUserProfiles(userIds as number[]);
    }

    comments.forEach(comment => {
      if (comment.isDeleted) {
        this.deleteComment(comment.id);
      } else if (!comment.threadId) {
        if (!this.findAndUpdateComment(this.comments, this.preprocessComment(comment))) {
          this.$emit('newComment', comment);
        }
      } else {
        this.findAndUpdateCommentInThreads(this.comments, comment);
      }
    });

    this.loadAbsentUserProfiles(userIds as number[]);
  }

  // обновление комментариев, полученных периодическим запросом к бекенду
  private async refreshComments() {
    try {
      const updatedComments = await this.getCommentUpdates();

      if (updatedComments.updated && updatedComments.updated.length) {
        let userIds: number[] = updatedComments.updated.map((comment: Comment) => comment.userId);
        const commentsInThreads = updatedComments.updated.filter((comment: Comment) => comment.threadId),
          commentsNotInThreads = updatedComments.updated.filter((comment: Comment) => !comment.threadId);

        commentsNotInThreads.forEach((comment: Comment) => {
          this.findAndUpdateComment(this.comments, this.preprocessComment(comment));
        });

        commentsInThreads.forEach((comment: Comment) => {
          if (this.findAndUpdateCommentInThreads(this.comments, comment, false)) {
            userIds.push(comment.userId);
          }
        });

        // не нужно загружать профиль автора анонимного тикета
        userIds = userIds.filter(userId => userId !== this.hideUserId);

        await this.loadAbsentUserProfiles(userIds);
        this.addAnonymousProfile();
      }

      if (updatedComments?.deleted?.length) {
        updatedComments.deleted.forEach((commentId: string) => {
          this.deleteComment(commentId);
        });
      }
      this.lastUpdatedAt = updatedComments.updatedAt;
    } catch (err) {
      this.$store.dispatch('reportException', err, { root: true });
      return Promise.reject();
    }
  }

  // удаление комментария по его идентификатору
  deleteComment(commentId: string) {
    if (!this.deleteCommentFromFirstLevel(this.comments, commentId)) {
      this.comments.some(comment => {
        if (comment.thread) {
          return this.deleteCommentFromFirstLevel((comment.thread as CommentsBlock).comments, commentId);
        }
        return false;
      });
    }
  }

  async handleEvent(event: Event) {
    if (event.type === 'visibilitychange') {
      if (!document.hidden) {
        this.refreshComments();
      }
    }
  }

  private highlightComment(comment: Comment) {
    const element: HTMLElement | null = this.getCommentElement(comment);
    if (element) {
      element.classList.add('comment_selected');
      setTimeout(() => {
        element.classList.remove('comment_selected');
      }, 1500);
    }
  }

  private getCommentElement(comment: Comment): HTMLElement | null {
    return document.getElementById(`cid-${comment.id}`);
  }

  @Watch('commentIdToAnswer')
  private showPanel(newCommentIdToAnswer: string) {
    if (!this.isShowAnswerPanel && newCommentIdToAnswer) {
      this.isShowAnswerPanel = true;
    }
  }

  private handleServerError(error: AxiosError) {
      let message = this.$t("common.errorTitle").toString();

      if(error.response?.data?.code) {
          message = this.$t(error.response?.data.code).toString();
      }
      else if(!error.response) {
          message = error.message;
      }

      const popup = new Popup({
          text: message,
          type: 'alert'
      });

      this.$store.dispatch('reportError', error);
  }
}
